import React from 'react';

const styles = {
    container: {
        textAlign: 'left',
        backgroundColor: 'white', // Fondo azul
        color: 'black', // Texto en blanco
        padding: '20px',
    },
    content: {
        maxWidth: '800px',
        margin: '0 auto',
    },
};


const DeleteAccountSteps = () => {
    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <h2>Pasos para Solicitar la Eliminación Manual de Datos en RaDi Languages</h2>
                <br />
                <ol>
                    <li>
                        <p>Preparación de la Solicitud: Antes de comenzar el proceso, asegúrate de tener a mano la información necesaria, como tu nombre de usuario y otra información identificativa que pueda ser requerida.</p>
                    </li>
                    <br />
                    <li>
                        <p>Contacto: Abre tu aplicación de mensajería en tu dispositivo móvil y crea un nuevo mensaje de texto o WhatsApp.</p>
                    </li>
                    <br />
                    <li>
                        <p>Destinatario: En el campo de destinatario, introduce el número de teléfono de contacto de RaDi Languages: <strong>+51975400190</strong>.</p>
                    </li>
                    <br />
                    <li>
                        <p>Mensaje: En el cuerpo del mensaje, escribe lo siguiente:</p>
                        <pre>
                            {`Hola equipo de RaDi Languages,

Deseo solicitar la eliminación de mi cuenta y datos personales en RaDi Languages.

Nombre de Usuario: [Tu Nombre de Usuario]

Por favor, procedan con la eliminación de mis datos de acuerdo con la política de privacidad de la aplicación.

Gracias.`}
                        </pre>
                        <p>Asegúrate de completar la información relevante, incluyendo tu nombre de usuario en RaDi Languages.</p>
                    </li>
                    <br />
                    <li>
                        <p>Enviar el Mensaje: Una vez que hayas redactado el mensaje, envíalo al número de teléfono de contacto de RaDi Languages: <strong>+51975400190</strong>.</p>
                    </li>
                    <br />
                    <li>
                        <p>Espera la Confirmación: El equipo de soporte de RaDi Languages recibirá tu solicitud y se pondrá en contacto contigo a través del mismo medio (mensaje de texto o WhatsApp) para confirmar tu identidad y verificar la solicitud.</p>
                    </li>
                    <br />
                    <li>
                        <p>Verificación de Identidad: Durante la verificación, es posible que te soliciten información adicional o que respondas preguntas de seguridad para garantizar que eres el titular de la cuenta.</p>
                    </li>
                    <br />
                    <li>
                        <p>Confirmación de Eliminación: Una vez que tu identidad haya sido verificada y el equipo de soporte haya procesado tu solicitud, recibirás una confirmación de que tus datos personales han sido eliminados de manera efectiva.</p>
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default DeleteAccountSteps;
